import {
  SiteConfigContext,
  SiteConfigQuery,
} from "../contexts/SiteConfigContext";
import React, { useCallback, useEffect, useState } from "react";
import { graphql, PageProps, StaticQuery, useStaticQuery } from "gatsby";
import { CurrentUser, GlobalContext } from "../contexts/GlobalContext";
import { Toaster, toast } from "react-hot-toast";
import { useMount } from "react-use";
import { TOKEN_KEY } from "constants";
import { getCurrentUser, getWeChatJsApiSig } from "api";
import { AxiosError } from "axios";
import { TRACK_EVENT_NAME } from "constants";
import { getTimestampInSeconds, isPc, trackEvent } from "utils";
import { FromTypeMap } from "constants";
import PcPage from "./pc-page";
import "../styles/global.scss";
import ClientOnly from "./clientOnly";
import { deployFolder } from "constants";
import useIsLandSpace from "hooks/useIsLandSpace";

declare global {
  interface Window {
    thinkingdata: {
      init: (config: unknown) => void;
      login: (tag: string) => void;
      track: (event: string, params: unknown) => void;
    };
  }
}

export default function Layout(props: PageProps<any>) {
  const [currentUser, setCurrentUser] = useState<CurrentUser | null>(null);
  const [needLogin, setNeedLogin] = useState<boolean>(false);
  const isLandSpace = useIsLandSpace();

  // 获取网站配置
  const data = useStaticQuery<{
    configJson: SiteConfigQuery;
    remoteActivityConfig: any;
  }>(graphql`
    query SiteConfigQuery {
      configJson {
        trackEventName
        domain
        shareImg
        shareTitle
        weiboShareDesc
        wxShareDesc
        activityId
        loading_page {
          loadingBgColor
          loadingPrimaryColor
          loadingBorderColor
        }
        home_page {
          game_download_url
          taobao_url
          show_taobao
          minigameUrl
        }
      }
      remoteActivityConfig {
        activityConfig {
          startTs
          endTs
          shopModuleConfig {
            sku
            type
            name
            cover
            price
            limit
            extraArg
          }
          miniGameModuleConfig {
            gameId
            challengeCount
            sharedCount
            sharedPoint
            successPoint
            failurePoint
          }
          checkInModuleConfig {
            total
          }
        }
      }
    }
  `);

  const initWechatJsSdk = useCallback(() => {
    if (data && data.configJson) {
      const config = data.configJson;
      let authUrl = props.location.href;
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        authUrl = localStorage.getItem("firstURL");
        if (!authUrl) authUrl = props.location.href;
      }

      getWeChatJsApiSig(authUrl).then(({ data }) => {
        const { data: resData } = data;
        window.wx.config({
          debug: false,
          appId: "wx89cb275016675513",
          timestamp: resData.timestamp, // 必填，生成签名的时间戳
          nonceStr: resData.nonceStr, // 必填，生成签名的随机串
          signature: resData.signature, // 必填，签名
          jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 必填，需要使用的JS接口列表
        });

        window.wx.ready(function () {
          window.wx.onMenuShareAppMessage({
            title: config.shareTitle,
            desc: config.wxShareDesc, // 分享描述
            link: `${
              config.domain
            }/h5activity/${deployFolder}/?fromType=2&t=${Number(new Date())}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: config.shareImg, // 分享图标
          });
          window.wx.onMenuShareTimeline({
            title: config.wxShareDesc,
            link: `${
              config.domain
            }/h5activity/${deployFolder}/?fromType=3&t=${Number(new Date())}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: config.shareImg, // 分享图标
          });
        });
      });
    }
  }, [data]);

  useMount(() => {
    localStorage.setItem("firstURL", window.location.href);
  }, []);

  useEffect(() => {
    const firstURL = localStorage.getItem("firstURL");
    if (!firstURL) {
      localStorage.setItem("firstURL", window.location.href);
    }
  });

  useMount(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      getCurrentUser(data.configJson.activityId, token)
        .then((res) => {
          const resData = res.data;
          if (resData) {
            setCurrentUser(resData.data);
            setNeedLogin(false);
          }
        })
        .catch((error: AxiosError) => {
          // if (error.response?.status == 401) {
          //   toast.error('请登录')
          // }
          setNeedLogin(true);
        });
    } else {
      setNeedLogin(true);
    }

    initWechatJsSdk();
  });

  useMount(() => {
    const taConfig = {
      appId: "fcca4d887e8f48ba8687e24a813f1289",
      serverUrl: "https://ta.cisgames.cn",
    };
    window.thinkingdata.init(taConfig);
    const params = new URLSearchParams(props.location.search);
    const fromType = params.get("fromType");
    if (fromType && FromTypeMap[fromType]) {
      trackEvent("referral_traffic", FromTypeMap[fromType]);
    }
  });

  // data.remoteActivityConfig.activityConfig.endTs < getTimestampInSeconds();
  const isExpire = false;
  return (
    <SiteConfigContext.Provider
      value={{
        ...data.configJson,
        ...data.remoteActivityConfig,
      }}
    >
      <GlobalContext.Provider
        value={{
          currentUser,
          setCurrentUser,
          needLogin,
          setNeedLogin,
        }}
      >
        <ClientOnly>
          {isPc()? (
            <PcPage />
          ) : isExpire ? (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "beige",
                color: "#45433f",
              }}
            >
              <h1
                style={{
                  textAlign: "center",
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  transform: "translate3d(-50%, -50%, 0)",
                }}
              >
                活动已结束
              </h1>
            </div>
          ) : (
            <>
              {props.children}
              <div>
                <Toaster />
              </div>
            </>
          )}
        </ClientOnly>
      </GlobalContext.Provider>
    </SiteConfigContext.Provider>
  );
}
